import React from "react";
import AuctionPainting from "../../images/home/banner/starry.jpg"; 
import { MdArrowForward } from "react-icons/md";
import Fadeup from "../fadeup/Fadeup";
import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <section className="sec_pd">
      <div className="">
        <Fadeup delay={0.3}>
        <h3 className="text-center mt-5 mb-4 mx-3 pb-2 text-black fs_40">
        Prestige Art & Antiques Auction
      </h3>
        </Fadeup>
     <Fadeup delay={0.2}>
     <p className="text-center mb-4 mx-3 border-bottom pb-2 text-black">
        Indulge in the finest selection of rare art, sculptures, and vintage treasures at our exclusive live auction. <br /> Each piece tells a story of heritage and artistic brilliance. Don't miss your opportunity to bid on history!
      </p>
     </Fadeup>

        <div 
          className="row d-flex align-items-center floral-border justify-content-center bg-light banner_row text-center text-md-start mt-5 "
          style={{ minHeight: "60vh" }}
        >
        
          <div className="col-md-12 col-lg-6 d-flex flex-column align-items-center align-items-md-center">
          <h3 className="text-black">Vincent Vangogh</h3>
            <h5 className=" text-black ">The Starry Night</h5>
            
            <p className="text-muted">By Renowned Artist • 1892</p>
            <h4 className="text-danger fw-bold">$15,000</h4>
            <p className="text-muted">Auction Ends: <strong>June 30, 2025</strong></p>
            {/* <Link
                    to='/auction'
                    className="btn signup-btn text-white  position-relative overflow-hidden border-0"
                  >
                    <div className="swift-btn_animation d-flex justify-content-center align-items-center" style={{background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))", }}>
                      <p className="m-0 text-black fw-bold button_name">
                        Place Bid
                      </p>
                    </div>
                  </Link> */}
          </div>

          <div className="col-md-12 col-lg-6 mt-md-5 d-flex justify-content-center">
            <img 
              src={AuctionPainting} 
              alt="Auction Painting" 
              className="img-fluid rounded shadow-lg auction_img "
              style={{ maxHeight: "600px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
